<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="14"
        height="33"
        viewBox="0 0 14 33"
    >
        <defs>
            <path id="a" d="M0 0h16.799v48.69H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 14 -8)">
            <mask id="b" fill="#fff">
                <use xlink:href="#a" />
            </mask>
            <path
                id="kk-prev-arrow"
                :fill="color"
                d="M12.003 20.002L-8 0v5.656L9.175 22.83a2.146 2.146 0 0 1 0 3.03L-8 43.034v5.656l20.003-20.002a6.148 6.148 0 0 0 0-8.686"
                mask="url(#b)"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'kkPrev',
    props: {
        color: {
            type: String,
            default: '#7B7B7B',
        },
    },
};
</script>
